var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { staticClass: "mx-1 mb-2", attrs: { dense: "" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "6", sm: "4", md: "" } },
        [
          _c(
            "v-card",
            {
              class: [
                "indicator-card",
                _vm.activeFilter === null ? "indicator-card--active" : "",
              ],
              attrs: { outlined: "", ripple: true },
              on: {
                click: function ($event) {
                  return _vm.filterByStatus(null)
                },
              },
            },
            [
              _c(
                "v-card-text",
                { staticClass: "text-center pa-3" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mb-1", attrs: { color: "primary" } },
                    [_vm._v("mdi-file-document-multiple-outline")]
                  ),
                  _c(
                    "div",
                    { staticClass: "text-h5 font-weight-bold primary--text" },
                    [_vm._v(_vm._s(_vm.loading ? "..." : _vm.indicators.total))]
                  ),
                  _c("div", { staticClass: "caption grey--text" }, [
                    _vm._v("Total"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(_vm.indicators.by_status, function (item) {
        return [
          _c(
            "v-col",
            { key: item.id, attrs: { cols: "6", sm: "4", md: "" } },
            [
              _c(
                "v-card",
                {
                  class: [
                    "indicator-card",
                    _vm.activeFilter === item.id
                      ? "indicator-card--active"
                      : "",
                  ],
                  attrs: { outlined: "", ripple: true },
                  on: {
                    click: function ($event) {
                      return _vm.filterByStatus(item.id)
                    },
                  },
                },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "text-center pa-3" },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mb-1",
                          attrs: { color: _vm.statusColor(item.id) },
                        },
                        [_vm._v(_vm._s(_vm.statusIcon(item.id)))]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "text-h5 font-weight-bold",
                          class: _vm.statusColor(item.id) + "--text",
                        },
                        [_vm._v(_vm._s(_vm.loading ? "..." : item.total))]
                      ),
                      _c("div", { staticClass: "caption grey--text" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          item.id === 1
            ? _c(
                "v-col",
                {
                  key: "teacher-pending",
                  attrs: { cols: "6", sm: "4", md: "" },
                },
                [
                  _c(
                    "v-card",
                    {
                      class: [
                        "indicator-card",
                        _vm.activeFilter === "teacher_pending"
                          ? "indicator-card--active"
                          : "",
                      ],
                      attrs: { outlined: "", ripple: true },
                      on: {
                        click: function ($event) {
                          return _vm.filterByStatus("teacher_pending")
                        },
                      },
                    },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "text-center pa-3" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mb-1",
                              attrs: { color: "amber darken-2" },
                            },
                            [_vm._v("mdi-account-clock-outline")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-h5 font-weight-bold amber--text text--darken-2",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.loading
                                    ? "..."
                                    : _vm.indicators.teacher_pending || 0
                                )
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "caption grey--text" }, [
                            _vm._v("Docentes Pendentes"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }